import * as React from 'react';

export function AdminEmail(): JSX.Element {
    return <a href="mailto:tsundraki@gmail.com" className='link-text-underline'>tsundraki@gmail.com</a>
}
